import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import { secondaryBlockDefaultStyles } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import {
  createButtonBlock,
  createH1Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBackgroundImageOptions } from "@circle-react-shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getColorOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import placeholderImage from "./homepage_block_1_default_image.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "EvergreenHomepageBlock1",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH1Block({
          text: "Build something meaningful together",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
        createPBlock({
          text: "Turn your knowledge into a structured, scalable course—without burnout. Get the clarity, strategy, and tools to lead a transformational learning experience.",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          styles: {
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "none",
                width: "100%",
                height: "100%",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
          },
        }),
      ],
    },
    buttons: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Enroll now",
          href: "#",
          buttonType: "secondaryButton",
        }),
        createButtonBlock({
          text: "Schedule a call",
          href: "#",
          buttonType: "customButton",
          styles: {
            default: {
              color: getColorOptions(
                "var(--theme-website-primary-button-default-text-color)",
              ),
              backgroundColor: getBackgroundColorOptions({
                defaultValue: "transparent",
              }),
            },
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: "var(--theme-website-color-6)",
        }),
        backgroundImage: getBackgroundImageOptions(),
        padding: getPaddingOptions({
          defaultValue: secondaryBlockDefaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: secondaryBlockDefaultStyles.margin,
        }),
      },
    },
  },
};
